import React from 'react';
import { TrendingUp, TrendingDown, Minus, BoxIcon } from 'lucide-react';
interface StatsCardProps {
  title: string;
  value: string | number;
  icon: BoxIcon;
  trend?: 'up' | 'down' | 'neutral';
  trendValue?: string;
  color?: 'green' | 'blue' | 'amber' | 'red';
}
export function StatsCard({
  title,
  value,
  icon: Icon,
  trend,
  trendValue,
  color = 'green'
}: StatsCardProps) {
  const colorMap = {
    green: 'text-emerald-600 bg-emerald-50 border-l-emerald-500',
    blue: 'text-blue-600 bg-blue-50 border-l-blue-500',
    amber: 'text-amber-600 bg-amber-50 border-l-amber-500',
    red: 'text-red-600 bg-red-50 border-l-red-500'
  };
  const trendColor = {
    up: 'text-emerald-600',
    down: 'text-red-600',
    neutral: 'text-gray-500'
  };
  return <div className={`bg-white rounded-lg shadow-sm border border-gray-100 p-6 border-l-4 ${colorMap[color].split(' ').pop()}`} data-id="element-138">
      <div className="flex items-center justify-between mb-4" data-id="element-139">
        <h3 className="text-sm font-medium text-gray-500" data-id="element-140">{title}</h3>
        <div className={`p-2 rounded-lg ${colorMap[color].replace(/border-l-\w+/, '')}`} data-id="element-141">
          <Icon className="w-5 h-5" data-id="element-142" />
        </div>
      </div>
      <div className="flex items-baseline justify-between" data-id="element-143">
        <p className="text-2xl font-bold text-gray-900" data-id="element-144">{value}</p>
        {trend && <div className={`flex items-center text-sm font-medium ${trendColor[trend]}`} data-id="element-145">
            {trend === 'up' && <TrendingUp className="w-4 h-4 mr-1" data-id="element-146" />}
            {trend === 'down' && <TrendingDown className="w-4 h-4 mr-1" data-id="element-147" />}
            {trend === 'neutral' && <Minus className="w-4 h-4 mr-1" data-id="element-148" />}
            {trendValue}
          </div>}
      </div>
    </div>;
}